module.exports = "<!-- <form class=\"sidebar-form\"></form> -->\n"